export const CalendarDateEntryNote = () => {
  return (
    <div className={'calendar-date-note'}>
      <div className={'calendar-status available'}>
        <i className={'icon-available'} />
        <span>{'…空きあり'}</span>
      </div>
      <div className={'calendar-status few-available'}>
        <i className={'ico-few-available'} />
        <span>{'…空きわずか'}</span>
      </div>
      <div className={'calendar-status no-available'}>
        <i className={'icon-no-available'} />
        <span>{'…空きなし'}</span>
      </div>
      <div className={'calendar-status closed'}>
        <i className={'icon-closed'} />
        <span>{'…定休日'}</span>
      </div>
    </div>
  );
};
